import Reception from './Reception';

export default Reception;
